import { defineStore } from 'pinia'

const useRobotsTxtStore = defineStore('robotsTxt', {
  state: () => ({}),
  actions: {},
})

export default useRobotsTxtStore
